import { requests } from "../actions";
import { get, post } from "../../../api";
import { getParameterByName } from "../../../utils";
import { getFullAddress } from "../helpers";

export const portalService = {
  getConfig: () => {
    const locationGroupId = getParameterByName("lg");
    let queryString = "";
    if (locationGroupId != null) {
      queryString = "?locationGroupId=" + locationGroupId;
    }
    const url = `portalsettings/configdetails${queryString}`;
    return get(url);
  },
  getSpecialties: () => {
    const url = "appointmentbooking/specialties?getAppointmentTypes=true";
    return get(url);
  },
  getPractitioners: () => {
    const url = "appointmentbooking/practitioners?getSpecialties=true";
    return get(url);
  },
  getLocations: () => {
    const locationGroupId = getParameterByName("lg");
    let queryString = "";
    if (locationGroupId != null) {
      queryString = "?locationGroupId=" + locationGroupId;
    }
    const url = `appointmentbooking/locations${queryString}`;
    return get(url);
  },
  getTimezones: () => {
    const url = "appointmentbooking/locationTimezones";
    return get(url);
  },
  getSchedules: (locationIds = null) => {
    const queryString = locationIds
      ? locationIds.map(locationId => `locationId=${locationId}`).join("&")
      : "";
    const url = `appointmentbooking/practitionerschedules?${queryString}`;
    return get(url);
  },
  getTimeSlots: (
    specialtyId,
    appointmentTypeId,
    locationIds,
    practitionerId,
    timeZoneId,
    start,
    end,
    phoneConsult = false
  ) => {
    const { token } = requests.getTimeSlots;

    let url = `appointmentbooking/timeslots?appointmentTypeId=${appointmentTypeId}&specialtyId=${specialtyId}&timezoneId=${timeZoneId}&phoneConsult=${phoneConsult}&start=${start}&end=${end}`;

    if (practitionerId !== "") {
      url += `&practitionerId=${practitionerId}`;
    }

    const locationStr = locationIds
      .map(locationId => `locationId=${locationId}`)
      .join("&");

    url += `&${locationStr}`;
    return get(url, { cancelToken: token });
  },
  requestVerificationCode: sms => {
    const url = "appointmentbooking/requestverificationcode";
    return post(url, sms);
  },
  verifyCode: sms => {
    const url = "appointmentbooking/verifycode";
    return post(url, sms);
  },
  getLocationPosition: location => {
    if (location.position) return;

    const address = getFullAddress(location);

    const url = `appointmentbooking/getlocationposition?address=${address}`;
    return get(url);
  },
  submitBooking: params => {
    const url = "appointmentbooking/submitbooking";
    return post(url, params);
  }
};



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/services/portalService.js